(function($, undefined) {
	'use strict';

	var init = function() {
		var logoCardsComponents = $('.com-logo-cards');

		$('.com-logo-cards__cards_slider').each(function(i, el) {
			initSlider($(el));
		});
	};

	function initSlider(slider) {
		const context = slider.closest('.com-logo-cards');
		const prevArrow = $('.com-logo-cards__nav-arrow_prev', context);
		const nextArrow = $('.com-logo-cards__nav-arrow_next', context);
		var isInFolder = context.closest('.folder-section').length > 0;
		console.log(isInFolder);
		slider.slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			prevArrow,
			nextArrow,
			responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: isInFolder ? 2 : 3
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: isInFolder ? 1 : 2
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 520,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
